import React, { useState } from "react";
import { DatePicker, Form } from "antd";
import InputField from "../../../Reuseable/InputField/InputField";
import CustomSelect from "../../../Reuseable/Select/Select";
import NormalButton from "../../../Reuseable/NormalButton/NormalButton";
import copyIcon from "../../../assets/Icons/copyIconTrust.svg";
import "./TargetAddNewTarget.scss";
import addIcon from "../../../assets/Icons/addIconTrust.svg";
import { ReactComponent as TrashIcon } from "../../../assets/Icons/trashcan.svg";
import RangePickerWithPresets from "../../../Reuseable/RengePicker/RangePickerWithPresets";

const TargetAddNewTarget = () => {
  const [form] = Form.useForm();
  const [targetRows, setTargetRows] = useState([
    { user: "", target: "", value: "" },
  ]);
  const { RangePicker } = DatePicker;

  const [dateRange, setDateRange] = useState({ startDate: "", endDate: "" });

  const userOptions = [
    { label: "Select", value: "" },
    { label: "User 1", value: "user1" },
    { label: "User 2", value: "user2" },
  ];

  const targetOptions = [
    { label: "Select", value: "" },
    { label: "Calls", value: "calls" },
    { label: "Conversions", value: "conversions" },
  ];

  const handleRowChange = (index, field, value) => {
    const updated = [...targetRows];
    updated[index][field] = value;
    setTargetRows(updated);
  };

  const addRow = (index) => {
    const updatedRows = [...targetRows];
    updatedRows.splice(index + 1, 0, { user: "", target: "", value: "" });
    setTargetRows(updatedRows);
  };

  const removeRow = (index) => {
    const updated = [...targetRows];
    updated.splice(index, 1);
    setTargetRows(updated);
  };

  const handleSave = () => {
    
  };

  const handleCancel = () => {
    setTargetRows([{ user: "", target: "", value: "" }]);
    setDateRange({ startDate: "", endDate: "" });
  };

  return (
    <div className="targetAddNewTarget">
      <h3 className="form-title">Add New Target</h3>

      <Form.Item
        label="Duration"
        name="duration"
        className="formItem calendar"
        rules={[{ message: "Please select a date range" }]}
      >
        <RangePickerWithPresets
          calendar
          style={{ width: "100%" }}
          format="DD/MM/YYYY"
        />
        {/* <RangePicker style={{ width: "100%" }} format="DD/MM/YYYY" /> */}
      </Form.Item>
      {targetRows.map((row, index) => (
        <div className="row-group" key={index}>
          <Form layout="vertical" className="row-form">
            <div className="form-row">
              <Form.Item>
                <CustomSelect
                  label="Users"
                  placeholder="Select"
                  value={row.user}
                  options={userOptions}
                  onChange={(val) => handleRowChange(index, "user", val)}
                />
              </Form.Item>
              <Form.Item>
                <CustomSelect
                  label="Select Target"
                  placeholder="Select"
                  value={row.target}
                  options={targetOptions}
                  onChange={(val) => handleRowChange(index, "target", val)}
                />
              </Form.Item>
              <Form.Item>
                <InputField
                  label="Target Value"
                  placeholder="Enter target value"
                  value={row.value}
                  onChange={(e) =>
                    handleRowChange(index, "value", e.target.value)
                  }
                />
              </Form.Item>
            </div>
          </Form>

          <div className="row-actions">
            <button className="copy" onClick={handleSave}>
              <img src={copyIcon} alt="" />
            </button>
            {index === 0 ? (
              <button className="icon-btn add" onClick={() => addRow(index)}>
                <img src={addIcon} alt="" />
              </button>
            ) : (
              targetRows.length > 1 && (
                <button
                  className="icon-btn delete"
                  onClick={() => removeRow(index)}
                  style={{ marginLeft: "4px" }}
                >
                  <span style={{ fontSize: "24px" }}>
                    <TrashIcon />
                  </span>
                </button>
              )
            )}
          </div>
        </div>
      ))}

      <div className="footer-buttons">
        {/* <NormalButton onClick={handleCancel} className="cancel-btn">
          Cancel
        </NormalButton> */}
        <button className="cancelBtn">Cancel</button>
        <NormalButton
          onClick={handleSave}
          className="submit-btn"
          style={{
            background: "linear-gradient(90deg, #f75b31 0%, #f8893e 100%)",
            border: "none",
          }}
        >
          Save Changes
        </NormalButton>
      </div>
    </div>
  );
};

export default TargetAddNewTarget;
